<template>
  <div class="container pt-5">
    <div class="row">
      <div class="col-4 col-sm-1 mt-5 mb-3"><div class="topic-separator w-100"></div></div>
    </div>
    <div class="row">
      <div class="col-12">
        <h2 class="h1 color-black">1. Add seed words</h2>
      </div>
      <div class="col-12 col-sm-7 secondary-font">
        Seed words will give the machine the direction in which you want the result to be.
        They can be connected to your topic, but also can be words that you believe sound nice.
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-sm-5">
        <div class="input-button-container mt-4 mb-2">
          <input type="text" v-model="inputWord"
                 placeholder="add a word and hit enter"
                 class="w-100 primary-font pr-5 text-button"
                 v-on:keyup.enter="addWord"/>
          <button class="add-button px-3" v-on:click="addWord">Add</button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mb-4 secondary-font" v-if="words.length">
        <div class="float-left mr-3"><span class="icon-container"><SvgIcon icon="eye" class="icon-sm icon-add" title="get related words"/></span> view related words</div>
        <div class="float-left mr-3"><span class="icon-container"><SvgIcon icon="cross" class="icon-sm icon-add" title="get related words"/></span> remove word from list</div>
        <div class="float-left"><span class="icon-container icon-container--reverse"><SvgIcon icon="plus" class="icon-sm icon-add" title="get related words"/></span> add word suggestion to list</div>
      </div>
      <div class="col-12 col-sm-10">
        <WordsList />
      </div>
      <div class="col-12 col-sm-10">
        <WordsSuggestions />
      </div>
    </div>
  </div>
</template>

<script>
import WordsList from './WordsList';
import WordsSuggestions from './WordsSuggestions';
import uuidMixin from '../mixins/uuid.mixin';
import {ADD_WORD} from '../store/mutation-types';
import {GET_RECOMMENDATIONS} from '../store/action-types';
import SvgIcon from '@/components/SvgIcon';
import {mapState} from 'vuex';

export default {
  mixins: [uuidMixin],
  components: {
    WordsList,
    WordsSuggestions,
    SvgIcon
  },
  name: 'WordsInput',
  data: function () {
    return {
      inputWord: '',
    }
  },
  computed: {
    preparedWords: function () {
      return this.$store.state.words.map(word => word.toLowerCase().trim());
    },
    ...mapState([
      'words'
    ])
  },
  methods: {
    addWord() {
      if (!this.inputWord) {
        return;
      }
      this.inputWord.toLowerCase()
          .replace(new RegExp("[,./_()\"']+"), " ")
          .replace(new RegExp(" {2,}"), ' ')
          .trim()
          .split(' ').forEach( token => {
        this.$store.commit(ADD_WORD, {word: {
            uuid: this.uuidv4(),
            word: token
          }});
        // this.$store.dispatch(GET_RECOMMENDATIONS, token);
      });
      this.inputWord = '';
    },
  }
}
</script>

<style scoped lang="scss">
  .input-button-container{
    position: relative;

    .text-button {
      border: 1px solid $black;
      border-radius: 4px;
      height: 2.5rem;
      padding-left: 1rem;
    }

    .add-button {
      cursor: pointer;
      background-color: $primary;
      color: $black;
      border: none;
      border-radius: 4px;
      position: absolute;
      top: 1px;
      right: 1px;
      height: calc(100% - 2px);
    }
  }

  .icon-container {
      background-color: $black;
      border-radius: 4px;
      padding: 0 8px;

      .icon-sm {
          stroke: $primary;
      }
  }

  .icon-container--reverse {
    background-color: rgba($primary, .5);
      .icon-sm {
        stroke: $black;
      }
  }

</style>
